<template>
  <div class="empty-wrap">
    <img :src="empty" :width="imageSize" :height="imageSize" />
    <span v-if="$slots.text" :class="textClass || 'empty-text'">
      <slot name="text" />
    </span>
    <span v-else :class="textClass || 'empty-text'">{{
      $t('components.Empty.069c3ceff0d8e39e421217e5749a77f4')
    }}</span>
    <span v-if="description" class="empty-desc">
      {{ description }}
    </span>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { noDataSrcV2 } from '@/libs/img';

export default defineComponent({
  props: {
    description: {
      type: String,
      default: ''
    },
    imageSize: {
      type: Number,
      default: 100
    },
    textClass: {
      type: String,
      default: ''
    }
  },
  setup() {
    return {
      empty: noDataSrcV2
    };
  }
});
</script>

<style scoped lang="less">
.empty-wrap {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  .empty-text {
    margin-top: 12px;
    size: 16px;
    font-weight: 600;
    color: var(--text-neutral-color-text-primary);
    line-height: 24px;
  }
  .empty-desc {
    margin-top: 8px;
    font-size: 12px;
    font-weight: 400;
    color: var(--text-neutral-color-text-tertiary);
    line-height: 20px;
  }
  .empty-slot {
    margin-top: 12px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}
</style>
